import { Controller } from '@hotwired/stimulus'
import debounce from 'debounce'

export default class extends Controller {
  reset() {
    this.element.reset()
  }
}